import { useEffect, useState } from 'react'

import type { KyrgyzstanOrderData } from 'shared/api/kyrgyzstan/orders'
import { KyrgyzstanOrdersApi } from 'shared/api/kyrgyzstan/orders'
import { getApiErrorMessage } from 'shared/lib/errorText'

export const useKyrgyzstanOrderDetail = (orderId?: string) => {
  const [data, setData] = useState<KyrgyzstanOrderData | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!orderId) {
      setData(null)
      setError(null)
      return
    }

    const abortController = new AbortController()

    const fetchOrder = async () => {
      setIsLoading(true)
      setError(null)
      try {
        const { data: response } =
          await KyrgyzstanOrdersApi.getOrderDetail(orderId)
        if (!abortController.signal.aborted) {
          setData(response.data)
        }
      } catch (err) {
        if (!abortController.signal.aborted) {
          setError(getApiErrorMessage(err) ?? null)
          setData(null)
        }
      } finally {
        if (!abortController.signal.aborted) {
          setIsLoading(false)
        }
      }
    }

    void fetchOrder()

    return () => {
      abortController.abort()
    }
  }, [orderId])

  return {
    data,
    isLoading,
    error,
  }
}
